import { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Enter } from 'components/icons';
import { cn } from 'lib/utils';

const PrimaryTarget = forwardRef(function TargetSection(
  {
    query,
    label,
    id,
    isPreSelected = false,
    onTargetClick,
    setCurrentSelection,
  },
  ref
) {
  const { t } = useTranslation();
  return (
    <div
      ref={ref}
      onClick={() => onTargetClick(id)}
      onMouseEnter={() => setCurrentSelection(id)}
      onMouseLeave={() => setCurrentSelection()}
      className={cn(
        'group flex items-center space-x-2 p-4 text-sm text-smd-main hover:cursor-pointer hover:bg-smd-gray-lighter',
        isPreSelected ? 'bg-smd-gray-lighter' : 'bg-white'
      )}
    >
      <div className="shrink-0">
        <Enter className="h-6 w-6" />
      </div>
      <div className="elipsis">{query}</div>
      <div className="shrink-0 rounded-md bg-smd-accent-light p-1">
        <span className="capitalize">{t('common.in')}</span>: {label}
      </div>
    </div>
  );
});

export default PrimaryTarget;
